export default __webpack_public_path__ + "static/media/gaming_Footer_Playtech_Supplier.caf5c65e.svg";